import React from 'react';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import { makeStyles } from '@material-ui/core/styles';
import {useParams} from "react-router-dom";
import Constants from "../../utils/constants";

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingTop: '50px',
    backgroundColor: 'white',
    height: '100%',
  },
}));

export default function InitiativeCardLayout({children}) {
  const classes = useStyles();
  const params = useParams();
  const createMenus = (path, name) => {
    return {path, name};
  };

  const menus = [
    createMenus('/', 'All Initiatives'),
    createMenus(Constants.nullPath, '>'),
    createMenus(Constants.nullPath, params.id)
  ];

  return (
    <div id="body-container">
      <DashboardHeader menus={menus} showCreateInitiative={false} />
      <div className={classes.wrapper}>
        {children}
      </div>
      <DashboardFooter />
    </div>
  );
}
